<template>
  <TemplateLogin
    hide-back-button
    @submit="signup"
  >
    <CalicoBanner
      v-if="errorMessage"
      variant="error"
      fixed
    >
      <span class="body--medium">{{ errorMessage }}</span>
    </CalicoBanner>
    <CalicoForm
      v-slot="{ field, error }"
      name="firstName"
      label="First Name"
      rules="required"
    >
      <CalicoField
        v-model="firstName"
        v-bind="field"
        :error="error"
      />
    </CalicoForm>
    <CalicoForm
      v-slot="{ field, error }"
      name="lastName"
      label="Last Name"
      rules="required"
    >
      <CalicoField
        v-model="lastName"
        v-bind="field"
        :error="error"
      />
    </CalicoForm>
    <CalicoForm
      v-slot="{ field, error }"
      name="email"
      label="Work Email"
      rules="required|email"
    >
      <CalicoField
        v-model="email"
        v-bind="field"
        :error="error"
      />
    </CalicoForm>
    <CalicoForm
      v-slot="{ field, error }"
      name="password"
      label="Password"
      rules="required|password"
    >
      <CalicoField
        v-model="password"
        v-bind="field"
        :error="error"
        :type="showPassword ? 'password' : 'text' "
        icon="eye"
        @click="showPasswordToggle"
      />
    </CalicoForm>
    <CalicoForm
      v-slot="{ field, error }"
      name="reTypePassword"
      label="Re-type Password"
      rules="required|confirmed:password"
    >
      <CalicoField
        v-model="reTypePassword"
        v-bind="field"
        :error="error"
        :type="showReTypePassword ? 'password' : 'text' "
        icon="eye"
        @click="showRetypePasswordToggle"
      />
    </CalicoForm>
    <button 
      class="button-primary" 
      type="submit"
      :disabled="loading || !appCheckReady" 
    >
      Sign Up
    </button>
    <div class="label--small">
      By clicking <strong>Sign Up</strong>, you agree to the
      <a
        :href="msaUrl"
        target="_blank"
        class="link"
      >Master Service Agreement</a>,
      <a
        :href="termsUrl"
        target="_blank"
        class="link"
      >Terms of Service</a>,
      and
      <a
        :href="privacyUrl"
        target="_blank"
        class="link"
      >Privacy Policy</a>
      for BetaScore.
    </div>

    <span
      class="body--medium"
      style="display: flex; flex-wrap: wrap;"
    >
      Have an account?&nbsp;
      <div>
        <button
          class="button-link" 
          @click="$router.push('/login')"
        >
          Login
        </button>
      </div>
    </span>
  </TemplateLogin>
</template>

<script lang="js">
import CalicoBanner from '@/components/calico/banner/index.vue'
import CalicoField from '@/components/calico/field/index.vue'
import CalicoForm from '@/components/pattern/form/index.vue'
import TemplateLogin from '@/components/template/login/index.vue'
import { useForm } from 'vee-validate';
import { getToken } from "firebase/app-check";
import { appCheck } from "@/main";
import Auth from "@/services/auth";
import { LegalLinks } from '@/enums';

export default {
  name: 'SignUp',
  components: {
    CalicoBanner,
    CalicoField,
    CalicoForm,
    TemplateLogin
  },
  setup() {
    const { validate } = useForm(); // Correct: Initializes form-wide validation tracking
    return { validate };
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      reTypePassword: "",
      errorMessage: "",
      loading: false,
      showPassword: true,
      showReTypePassword: true,
      appCheckReady: false,
      msaUrl: LegalLinks.MSA_URL,
      termsUrl: LegalLinks.TERMS_URL,
      privacyUrl: LegalLinks.PRIVACY_URL
    }
  },
  mounted() {
    getToken(appCheck, false)
      .then(t => { this.appCheckReady = !!(t && t.token); })
      .catch(() => { this.appCheckReady = false; });
  },
  methods: {
    async signup(validate) {
      this.loading = true;
      try {
        const result = await validate();
        if (!result.valid) return;

        await Auth.signup({
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
        });

        this.$router.push("/verify-email");
      } catch (error) {
        console.log(error);

        const code = error?.code || "";
        if (code === "auth/email-already-in-use") this.errorMessage = "Email already in use.";
        else if (code === "auth/invalid-email") this.errorMessage = "Invalid email format.";
        else this.errorMessage = "Error creating user:";      

      } finally {
        this.loading = false;
      }
    },
    showPasswordToggle(e) {
      if(e.target.tagName.toLowerCase() === 'i') {
        this.showPassword = !this.showPassword
      }
    },
    showRetypePasswordToggle(e) {
      if(e.target.tagName.toLowerCase() === 'i') {
        this.showReTypePassword = !this.showReTypePassword
      }
    }
  }
}
</script>

<style lang="scss">
</style>
